import React, { useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import { ReactComponent as SolarSystem } from './ecosystem1.svg'

import Stars from './stars.svg'
import { Dots } from 'pages/Pool/styleds'

const endFadeOut = keyframes`
 from {
    opacity: 1;
    transform: translateY(-10px);
  }
  to {
    opacity: 0;
    transform: translateY(0);
  }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const ContainerStyled = styled.div`
  max-width: 100vw;
  max-height: calc(100vh - 300px);

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 14px;

  height: 100vh;
  width: 100vw;

  padding: 16px;
  overflow: visible;

  position: relative;

  img,
  svg {
    max-height: 100%;
  }

  &.fadeOut {
    #ecosystem,
    .stars,
    .stars2 {
      animation: ${endFadeOut} 1s ease forwards;
    }
  }

  @keyframes glow {
    from {
      filter: drop-shadow(0 0 1px white);
      opacity: 0.1;
    }
    to {
      filter: drop-shadow(0 0 8px white);
      opacity: 1;
    }
  }
  @keyframes glow2 {
    from {
      filter: drop-shadow(0 0 8px white);
      opacity: 1;
    }
    to {
      filter: drop-shadow(0 0 1px white);
      opacity: 0.1;
    }
  }
  .stars {
    position: absolute;
    height: 100vh;
    filter: drop-shadow(0 0 6px white);
    animation: glow 4s ease-in-out infinite alternate;
    @media (min-width: 768px) {
      max-height: unset;
      height: unset;
      width: 100vw;
    }
    @media (max-width: 768px) {
      height: 100vh;
      max-width: unset;
      max-height: unset;
      width: unset;
    }
  }

  .stars2 {
    transform: rotate(90deg);
    position: absolute;
    height: 100vh;
    filter: drop-shadow(0 0 6px white);
    animation: glow2 4s ease-in-out infinite alternate;
    @media (min-width: 768px) {
      max-height: unset;
      height: unset;
      width: 100vw;
    }
    @media (max-width: 768px) {
      height: 100vh;
      max-width: unset;
      max-height: unset;
      width: unset;
    }
  }

  #ecosystem {
    width: 100%;
    height: 100%;
    animation: ${fadeIn} 0.3s ease-out;
    margin: 0 auto;
    overflow: visible;
    z-index: 1;
    max-width: 400px;

    @media (max-width: 768px) {
      max-width: 300px;
    }
  }

  .line {
    animation: colorShift 20s ease-in-out infinite;
  }

  .logoFirst {
  }

  .logoThatMoves {
    transform-origin: center;
  }

  .lineWithLogo {
    transform-origin: center;
  }

  @keyframes colorShift {
    0%,
    100% {
      stroke: #00ffff;
    }
    50% {
      stroke: #6cfd56;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes pulse {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
  }

  ${[1, 2, 3, 4, 5, 6, 7, 8]
    .map(
      (i) => `
    .spin${i} {
      animation: spin ${i * 14}s linear infinite;
      transform-origin: center;
    }
  `
    )
    .join('\n')}

  ${[1, 2, 3, 4, 5, 6, 7, 8]
    .map(
      (i) => `
      .pulsing${i} {
        animation: pulse ${i * 2}s ease-in-out infinite;
        transform-origin: center;
        transform-box: fill-box;
      }
    `
    )
    .join('\n')}
`

const EcosystemLoader: React.FC<{ styles?: React.CSSProperties; loading: boolean }> = ({ styles, loading }) => {
  useEffect(() => {
    const elements = document.getElementsByClassName('lineWithLogo')

    Array.from(elements).forEach((el) => {
      el.classList.add(`spin${Math.floor(Math.random() * (8 - 1) + 1)}`)
    })

    const logos = document.getElementsByClassName('logoThatMoves')
    Array.from(logos).forEach((el) => {
      el.classList.add(`pulsing${Math.floor(Math.random() * (8 - 1) + 1)}`)
    })
  }, [])

  return (
    <>
      <span
        style={{
          position: 'absolute',
          bottom: '20%',
          padding: '0 16px',
          textAlign: 'center',
          fontSize: '14px',
          fontFamily: 'Unbounded',
          color: '#C3C5CB',
        }}
      >
        <Dots>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#4AFC38"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-planet"
            style={{ verticalAlign: 'middle', marginRight: '8px' }}
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M18.816 13.58c2.292 2.138 3.546 4 3.092 4.9c-.745 1.46 -5.783 -.259 -11.255 -3.838c-5.47 -3.579 -9.304 -7.664 -8.56 -9.123c.464 -.91 2.926 -.444 5.803 .805" />
            <path d="M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
          </svg>{' '}
          Hold tight, we’re gathering your ecosystem points
        </Dots>
      </span>
      <ContainerStyled style={styles} className={loading ? '' : 'fadeOut'}>
        <img src={Stars} className="stars" alt="stars decorative" />
        <img src={Stars} className="stars2" alt="stars decorative" />
        <SolarSystem id="ecosystem" />
      </ContainerStyled>
    </>
  )
}

export default EcosystemLoader
